"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCardContent = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var StyledCardContent = function (_a) {
    var _b;
    var sections = _a.sections, children = _a.children;
    return (react_1.default.createElement(core_1.Card, __assign({ className: "card-wrapper" }, (_b = sections === null || sections === void 0 ? void 0 : sections.card) === null || _b === void 0 ? void 0 : _b.props),
        react_1.default.createElement(core_1.CardContent, null, children)));
};
exports.StyledCardContent = StyledCardContent;
//# sourceMappingURL=StyledCardContent.js.map